<nav class="navbar navbar-expand-lg navbar-light bg-light sticky-top fixed-top" *ngIf="isVisible">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/">
      <img [src]="logoImageUrl" class="logo">
    </a>

    <button class="navbar-toggler ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div *ngIf="isLoggedIn$ | async; else notLoggedIn" class="collapse navbar-collapse justify-content-end"
      id="navbarNav">

      <ul class="nav justify-content-end align-items-center">
        <li class="nav-item">
          <i class="bi bi-person"></i>&nbsp;
          <strong>{{ (user$ | async)?.nombre }} {{ (user$ | async)?.apellido_pat }} {{ (user$ | async)?.apellido_mat }}</strong>
        </li>
        <li class="nav-item">
          <a class="nav-link logout-link" [routerLink]="['/candidato-perfil']">Mi perfil</a>
        </li>
        <li class="nav-item">
          <a class="nav-link text-danger" (click)="logout()">Cerrar sesión</a>
        </li>
      </ul>

      <!-- <ul class="navbar-nav">
        <li class="nav-item">
          <i class="bi bi-person"></i>&nbsp;
          <strong>{{ (user$ | async)?.nombre }} {{ (user$ | async)?.apellido_pat }} {{ (user$ | async)?.apellido_mat }}</strong>
        </li>
        <li class="nav-item pl-1">
          <span class="logout-link" (click)="logout()">{{'logout' | translate}}</span>
        </li>
      </ul> -->
    </div>
    <ng-template #notLoggedIn>
      <div class="collapse navbar-collapse justify-content-end" id="navbarNav">

        <!-- Para desktop -->
        <div class="d-none d-md-flex gap-2 align-items-center">
          <a routerLink="/" class="btn btn-outline-primary rounded-pill px-3 d-flex align-items-center gap-2 btn-hover-animate">
            <i class="bi bi-briefcase-fill"></i> Vacantes
          </a>
          <a routerLink="/login" class="btn btn-outline-primary rounded-pill px-3 d-flex align-items-center gap-2 btn-hover-animate">
            <i class="bi bi-box-arrow-in-right"></i> {{'login' | translate}}
          </a>
          <a routerLink="/opciones-registro" class="btn btn-primary rounded-pill px-3 d-flex align-items-center gap-2 btn-hover-animate">
            <i class="bi bi-person-plus-fill"></i> {{'signup' | translate}}
          </a>
        </div>

        <!-- Para móvil, dentro del menú colapsable -->
        <div class="d-md-none d-flex flex-column gap-2 mt-3">
          <a routerLink="/" class="btn btn-outline-primary rounded-pill w-100 d-flex align-items-center justify-content-center gap-2">
            <i class="bi bi-briefcase-fill"></i> Vacantes
          </a>
          <a routerLink="/login" href="/login" class="btn btn-outline-primary rounded-pill w-100 d-flex align-items-center justify-content-center gap-2">
            <i class="bi bi-box-arrow-in-right"></i> {{'login' | translate}}
          </a>
          <a routerLink="/opciones-registro" class="btn btn-primary rounded-pill w-100 d-flex align-items-center justify-content-center gap-2">
            <i class="bi bi-person-plus-fill"></i> {{'signup' | translate}}
          </a>
        </div>

        <!-- <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" routerLink="login" routerLink="/login">{{'login' | translate}}</a>
          </li>
          <li class="nav-item">
            <div class="btn-signup justify-content-center">
              <a class="nav-link" routerLink="registro-corto" routerLink="/registro-corto">{{'signup' | translate}}</a>
            </div>

          </li>
        </ul> -->

      </div>
    </ng-template>
  </div>
</nav>